/** Names of used GA UA-format eCommerce events */
export enum GaUaEcommerceEvents {
	addToCart = 'addToCart',
	Checkout = 'Checkout',
	checkoutOption = 'checkoutOption',
	detail = 'detail',
	Impressions = 'Impressions',
	productClick = 'productClick',
	removeFromCart = 'removeFromCart'
}
